// This file is auto-generated by the codegen maintenance script
export const PACKAGE_VERSION = "15.28.0";
export const PACKAGE_NAME = "zwave-js";
